














import { Vue, Component } from 'vue-property-decorator';
import MainLayout from '../layouts/MainLayout.vue';

// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    MainLayout,
  },
})

export default class NotFoundPage extends Vue {
}
